module.exports = __webpack_public_path__ + "img/editor-footer.40ee3715.svg";